<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"
import { ArrowRightIcon } from "lucide-vue-next"
import { computed } from "vue"

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { type NavItem } from "@/types"

interface Props {
  items: NavItem[]
  class?: string
}

defineProps<Props>()

const page = usePage()
const hasManagerRoute = computed(() => page.url?.includes("/manager/") ?? false)

function isActive(href: string) {
  return page.url.startsWith(href)
}
</script>

<template>
  <div v-for="item in items" :key="item.title">
    <component
      v-if="!hasManagerRoute"
      class="bg-primary group mb-6 flex items-center justify-between gap-2 rounded-md px-3 py-2 text-white shadow-[0_5px_20px_rgba(20,71,230,0.45)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#153CB4] hover:drop-shadow-md"
      :is="item.external ? 'a' : Link"
      :href="item.href"
      :target="item.external ? '_blank' : undefined"
      :rel="item.external ? 'noopener noreferrer' : undefined"
    >
      <div class="flex gap-2">
        <component :is="item.icon" class="mt-1 size-5" />
        <div class="flex flex-col">
          <span class="font-sans">{{ item.title }}</span>
          <div class="-mt-1 -ml-0.5 flex items-center gap-1 pb-0.5 text-sm">
            <span
              class="flex size-3 items-center justify-center rounded-full bg-green-500/20"
            >
              <span
                class="size-1.5 rounded-full bg-green-500 group-hover:animate-pulse"
              />
            </span>
            <span class="text-xs text-white/70">Estamos en línea</span>
          </div>
        </div>
      </div>
      <ArrowRightIcon class="size-4 opacity-70" />
    </component>
    <SidebarMenuButton v-else size="xl" as-child :is-active="isActive(item.href)">
      <component
        :is="item.external ? 'a' : Link"
        :href="item.href"
        :target="item.external ? '_blank' : undefined"
        :rel="item.external ? 'noopener noreferrer' : undefined"
      >
        <component :is="item.icon" />
        <span class="font-sans">{{ item.title }}</span>
      </component>
    </SidebarMenuButton>
  </div>
</template>
